import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/login/LoginForm';
import { InputField } from '../components/login/InputField';
import { LoginButton } from '../components/login/LoginButton';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [usernameTouched, setUsernameTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setUsernameTouched(true);
    setPasswordTouched(true);
    setError(null);
    if (!username || !password) {
      setError('Usuário e senha são obrigatórios.');
      return;
    }
    setLoading(true);
    const result = await login(username, password);
    setLoading(false);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Erro ao autenticar.');
    }
  };

  const usernameError = usernameTouched && !username;
  const passwordError = passwordTouched && !password;

  return (
    <LoginForm onSubmit={handleSubmit}>
      <div style={{ marginBottom: 24 }}>
        <img src="assets/loading.png" alt="Logo" style={{ width: 70, height: 70 }} />
      </div>
      <h2 style={{ fontWeight: 700, fontSize: 24, margin: 0, marginBottom: 4, color: '#234C7C' }}>Bem-vindo à Gestão</h2>
      <div style={{ color: '#6CA0DC', fontSize: 15, marginBottom: 28 }}>Acesse sua conta para continuar</div>
      {error && (
        <div style={{ color: '#F44336', background: '#FFF0F0', borderRadius: 6, padding: '8px 12px', marginBottom: 16, width: '100%', textAlign: 'center', fontSize: 15 }}>
          {error}
        </div>
      )}

      <InputField
        label="Usuário"
        type="text"
        value={username}
        onChange={setUsername}
        onBlur={() => setUsernameTouched(true)}
        error={usernameError}
        errorMessage="Usuário é obrigatório"
        placeholder="Digite seu usuário"
        icon={
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M16 21v-2a4 4 0 0 0-8 0v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        }
        disabled={loading}
      />

      <InputField
        label="Senha"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={setPassword}
        onBlur={() => setPasswordTouched(true)}
        error={passwordError}
        errorMessage="Senha é obrigatória"
        placeholder="Digite sua senha"
        icon={
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="8" rx="4" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        }
        disabled={loading}
        showPasswordToggle
        onTogglePassword={() => setShowPassword(s => !s)}
        showPassword={showPassword}
      />

      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <label style={{ display: 'flex', alignItems: 'center', fontSize: 15, color: '#222', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={remember}
            onChange={e => setRemember(e.target.checked)}
            style={{ marginRight: 6 }}
            disabled={loading}
          />
          Lembrar-me
        </label>
        <a href="#" style={{ color: '#234C7C', fontSize: 15, textDecoration: 'none', fontWeight: 500 }}>Esqueci a senha?</a>
      </div>

      <LoginButton loading={loading} />

      {/* <div style={{ color: '#6B7280', fontSize: 14, marginTop: 18, textAlign: 'center' }}>
        Ainda não possui uma conta?{' '}
        <a
          href="/register"
          style={{ color: '#234C7C', textDecoration: 'none', fontWeight: 500 }}
        >
          Crie sua conta
        </a>
      </div> */}
    </LoginForm>
  );
};

export default Login;